import { FileStack, Sparkles, Tag } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const ComingSoon = () => {
  const { t } = useLang();

  return (
    <section
      id="coming-soon"
      data-testid="coming-soon-section"
      className="py-20 lg:py-28 border-t border-stone-200"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-stone-900 text-stone-100 rounded-3xl p-10 lg:p-14 overflow-hidden grain">
          <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-red-800/30 blur-3xl" />
          <div className="absolute -bottom-20 -left-10 w-72 h-72 rounded-full bg-green-700/20 blur-3xl" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <span
                data-testid="coming-soon-badge"
                className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-800/30 border border-red-700/40 text-red-200 font-mono-label"
              >
                <Sparkles size={12} /> {t.comingSoon.badge}
              </span>
              <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-stone-50">
                {t.comingSoon.title}
              </h2>
              <p className="mt-5 text-lg text-stone-300 leading-relaxed max-w-xl">
                {t.comingSoon.subtitle}
              </p>

              <ul className="mt-7 space-y-3 text-stone-200">
                <li className="flex items-start gap-3">
                  <FileStack size={18} className="text-green-400 shrink-0 mt-0.5" />
                  <span>{t.comingSoon.b1}</span>
                </li>
                <li className="flex items-start gap-3">
                  <Tag size={18} className="text-green-400 shrink-0 mt-0.5" />
                  <span>{t.comingSoon.b2}</span>
                </li>
                <li className="flex items-start gap-3">
                  <Sparkles size={18} className="text-green-400 shrink-0 mt-0.5" />
                  <span>{t.comingSoon.b3}</span>
                </li>
              </ul>

              <a
                href="#contact"
                data-testid="coming-soon-cta"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-stone-50 text-stone-900 font-semibold hover:bg-white transition-colors"
              >
                {t.comingSoon.cta}
              </a>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-stone-50/5 border border-stone-50/10 backdrop-blur-md rounded-2xl p-6">
                <p className="font-mono-label text-stone-400 mb-4">
                  {t.comingSoon.previewLabel}
                </p>
                <div className="space-y-3">
                  {[
                    { name: "ABC Traders", count: 14, amt: "₹1,24,500" },
                    { name: "XYZ Distributors", count: 8, amt: "₹78,200" },
                    { name: "Sunrise Agencies", count: 22, amt: "₹2,06,800" },
                    { name: "Patel & Sons", count: 5, amt: "₹34,950" },
                  ].map((r) => (
                    <div
                      key={r.name}
                      className="flex items-center justify-between bg-stone-50/[0.04] border border-stone-50/10 rounded-lg px-4 py-3"
                    >
                      <div>
                        <p className="font-display text-stone-50 text-base leading-tight">
                          {r.name}
                        </p>
                        <p className="text-xs text-stone-400 mt-0.5">
                          {r.count} {t.comingSoon.invoices}
                        </p>
                      </div>
                      <p className="font-display text-green-400">{r.amt}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
